import React from 'react';

const BlankLine = () => (
  <p className="message-content-blank-line" aria-hidden="true">
    {'\u00A0'}
  </p>
);

const renderParagraphs = (text, keyPrefix) =>
  text.split('\n\n').map((paragraph, index) => (
    <p key={`${keyPrefix}-${index}`} className="message-content-paragraph">
      {paragraph}
    </p>
  ));

/**
 * Welcome intro: one opening line with fox logo, then a blank line before the body.
 */
const WelcomeMessageContent = ({ lead, body }) => (
  <>
    <p className="message-content-paragraph">
      {lead}
      <img
        src="/revetall-icon.svg"
        alt=""
        aria-hidden="true"
        className="message-inline-avatar"
      />
    </p>
    <BlankLine />
    {renderParagraphs(body, 'body')}
  </>
);

export default WelcomeMessageContent;
